import gsap from 'gsap'
import ee from '../ee'

function numberWithCommas(number) {
  return Math.ceil(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

function animateStatModule({ element }) {
  let el_stat = element.querySelector('.stats-module__stat')
  let el_intro = element.querySelector('.stats-module__intro')
  let el_body = element.querySelector('.stats-module__body')

  let startValue = element.attributes['data-start-value'].value
  let endValue = element.attributes['data-end-value'].value
  let suffix = element.attributes['data-suffix'].value
  let prefix = element.attributes['data-prefix'].value

  let counter = { value: +endValue }

  const animations = {
    clearStatPosition() {
      return gsap
        .timeline()
        .set(element, { clearProps: true })
        .set(el_stat, { clearProps: true })
    },

    colorStat() {
      return gsap.from(el_stat, {
        opacity: 0,
        color: '#aaa9a9',
        ease: 'linear',
        duration: 0.5,
      })
    },

    setStatPosition() {
      return gsap
        .timeline()
        .set(element, { height: element.offsetHeight })
        .set(el_stat, {
          position: 'absolute',
          left: el_stat.offsetLeft,
          width: el_stat.offsetWidth,
          top: 0,
          textAlign: prefix ? 'left' : 'right',
        })
    },

    showIntro() {
      if (!el_intro) return null
      return gsap.from(el_intro, { opacity: 0, duration: 0.4 })
    },

    showBody() {
      if (!el_body) return null
      return gsap.from(el_body, { opacity: 0, duration: 0.7 })
    },
  }

  function onCounterUpdate() {
    el_stat.innerText = `${prefix}${numberWithCommas(counter.value)}${suffix}`
  }

  gsap
    .timeline({
      scrollTrigger: { trigger: element, start: '50px bottom', once: true },
    })
    .add(animations.setStatPosition())
    .add(animations.showIntro())
    .add(animations.colorStat())
    .from(
      counter,
      {
        value: startValue,
        ease: 'power4.out',
        duration: 1,
        onUpdate: onCounterUpdate,
      },
      '<'
    )
    .add(animations.clearStatPosition())
    .add(animations.showBody(), '+=0.1')
}

function init() {
  let statsModules = Array.from(document.querySelectorAll('.stats-module'))
  statsModules.forEach((element) => animateStatModule({ element }))
}

ee.addListener('initComponents', init)
